import React from 'react';
import { FadeIn } from './FadeIn';
export function SignaturePiece() {
  return <section className="py-32 md:py-48" data-id="element-125">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-126">
        <FadeIn data-id="element-127">
          <div className="relative w-full aspect-[21/9] min-h-[60vh] bg-gradient-to-r from-[#1a1a1a] to-[#2a2a2a] overflow-hidden flex items-center justify-center" data-id="element-128">
            {/* Abstract representation of the signature piece */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(196,165,114,0.15)_0%,transparent_60%)]" data-id="element-129" />

            <div className="relative z-10 text-center flex flex-col items-center px-6" data-id="element-130">
              <span className="label-tiny text-gold/80 mb-8" data-id="element-131">יצירת הדגל</span>
              <h2 className="serif text-4xl md:text-6xl text-ivory mb-10 max-w-2xl leading-tight" data-id="element-132">
                טבעת הכתר השחור
              </h2>
              <a href="#" className="label-tiny text-ivory border-b border-ivory/30 pb-1 hover:border-gold hover:text-gold transition-colors duration-500" data-id="element-133">
                גלו את הסיפור
              </a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}